<mat-dialog-content class="dialog-text">
  @switch (currentStep) {
    @case (1) {
      <app-message-provider-selection
        [isModal]="true"
        (providerUserIdSelected)="onSelection($event)"></app-message-provider-selection>
    }
    @case (2) {
      <app-topic-selection
        [providerUserId]="providerUserId!"
        [isModal]="true"
        (messageTopicIdSelected)="onSelection($event)"></app-topic-selection>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button id="cancelBtn" class="error-btn" (click)="close()">Cancel</button>
  @if (currentStep !== 1) {
    <button mat-stroked-button id="backBtn" class="secondary-btn" (click)="goBack()">Back</button>
  }
</mat-dialog-actions>
